export default {
  search: "搜索",
  clear: "清空條件",
  close: "關閉",
  load_more:'載入更多',
  required: "必填項",
  detail: "詳情",
  optional: "選填項",
  sku_detail: "產品詳情",
  verification_of_phone: "手機驗證",
  verification_of_email: "郵箱驗證",
  change_password: "修改密碼",
  forget_pwd: "忘記密碼",
  set_pwd: "設置密碼",
  next: "下壹步",
  "产品库":'產品庫',
  attend_sport:'掃一掃參加運動會',
  error: "錯誤",
  application:{
    "产品库": "產品推送查"
  },
  'Q&A':'Q&A',
  chatroom:'聊天室',
  //錯誤提醒
  errMsg: {
    "validation error": "驗證碼錯誤!",
    email_no_match_phone: "郵箱與手機號不匹配!",
    phone_no_match_email: "手機號與郵箱不匹配!",
    register_confirm_privacy: "如需註冊活動，請您查看並同意耐克的隱私政策。",
    user_not_exist: "用戶不存在",
    login_confirm_privacy: "如需登錄系統，請您查看並同意耐克的隱私政策。",
    "password error":"密碼錯誤",
    "BAD PASSWORD FORMAT": "密碼格式不對。",
    "TWO DIFFERENT PASSWORDS": "兩次密碼不壹致。",
    "NAME IS REQUIRED": "姓名為必填項。",
    "PASSWORD IS REQUIRED": "密碼為必填項。",
    "PHONE NUMBER AND EMAIL CAN'T BE EMPTY AT THE SAME TIME": "手機號與郵箱不能同時為空。",
    "ACCOUNT GROUP IS REQUIRED": "客戶組為必選項。",
    "GENDER IS REQUIRED": "性別為必選項。",
    "CHOOSE ONE OF ONLINE AND ONSITE AT LEAST.": "請線上上/現場這兩種參會方式中，至少選擇一項。",
    OKTA_Login_Fail: "OKTA登錄失敗，請點擊\"耐克內部員工登入\"嘗試再次登錄。",
    "MSG CANNOT BE EMPTY": "不能發送空消息。",
    "QUESTION CANNOT BE EMPTY": "問題不能為空。",
    "PROBLEM FEEDBACK FAILED": "問題反饋失敗。",
    "notice expired": "公告已過期。",
    "you have no permission": "您无权登录系统。",
    "no_phone": "手機號不能為空。",
    "no_email": "郵箱不能為空。",
    "incorrect email format": "郵箱格式不正確。",
    "no_validation_code": "驗證碼不能為空。",
    "same_phone": "新的手機號與舊的手機號相同，無需更新。",
    "phone number existed": "手機號已經存在，請使用其他手機號。",
    "email existed": "郵箱已經存在，請使用其他郵箱。",
    "no_username": "用戶名不能爲空。",
    "same_email": "新舊郵箱不能相同。",
    "wrong validation code, please check it again.": "驗證碼錯誤，請重新檢查您的驗證碼。",
    "invitation code is expired or reach allowed max user": "邀請碼過期或邀請人數已達上限。",
    "invitation code is reach allowed max user": "邀請碼的邀請人數已達上限。",
    "no attendee need to approve": "暫無需要審核的參會人。",
    "owner has completed request, not allow approve item again": "活動管理員已經完成審核，您無法再審核該申請。",
    "unable find invitation code": "無效邀請連接。",
    "invitation code is expired": "邀請鏈接已過期。",
    "request in progress": "您的申請在審批中",
    "request approved in this event": "您的申請已經通過",
    "login fail": "登錄失敗",
    "user blocked": "您的賬號已被停用。",
    "PHONE NUMBER AND EMAIL REQUIRED": "手機號與郵箱均為必填項。",
    "user have no email": "您沒有郵箱，請先維護郵箱。",
    "the image you uploaded is not in the right format": "您上傳的圖片格式不對, 圖片僅支持:jpg、png、jpeg格式!",
    "no access to login system": "您暫無權限登錄繫統。",
    "some bookmark not save": "有未保存的內容！",
    'you have already approved to join this event, no need to request': '您已加入該活動中，不需要重複註冊',
    "no users ro no sessions in this invitation": "此邀請中沒有參會人或沒有維護會議",
    "no chat history":"沒有歷史資訊",
    "you are not authorized as an broadcaster": "您暫無播音員權限",
    "chat message send error": "消息發送失敗，請稍後重試",
  },
  //成功提醒
  successMsg: {
    "copy successfully": "復製成功。",
    change_password_success: "修改密碼成功!",
    password_reset_succeeded: "重置密碼成功!",
    "send_email_validation_same_time": "如您無法收到短信驗證碼，系統已經同時將驗證碼發送到您註冊時填寫的郵箱中，請到收件箱中查看驗證碼。",
    "send_email_validation_success": "驗證碼已經發送到您的郵箱, 請注意查收!",
    "send_phone_validation_success": "驗證碼已經發送到您的手機, 請注意查收!",
    "the_reservation_email_has_been_sent": "預約郵件已發送!"
  },
  //提示資訊
  confirmMsg: {
    "confirm delete bookmark": "確認删除書簽？",
    no_event: '您目前暫無活動。',
    no_other_event: "您目前暫無其他活動",
    no_session: '您目前暫無會議。',
    no_notice: "暫無公告",
    preparatory_phase: "該活動正處於準備階段！",
    event_not_start: "活動暫未開啟，請等待!"
  },

  preview: "預覽",
  notice: "公告",
  view_detail: "查看詳情",
  notice_detail:{
    all: "全部",
    in_station: "站內",
    active: "活動",
    session: "會議",
    unread: "未讀",
    all_read: "全部已讀",
    view: "查看",
    accessory: "附件",
    accessory_name: "附件名稱",
    notice_name: "公告名稱",
    download_accessory: "下載附件",
    new_notice: "新增公告"
  },
  broadcast: {
    start_at: "直播將於{start_time}開始",
    start: "直播開始",
    thanks_for_watching: "感謝觀看直播！",
    start_time: "開始時間：{start_time}",
    will_go: "<span class='second'>{seconds}</span>秒後將為您自動跳轉至下一場會議",
    stop_go_btn: "暫不跳轉",
  },

  app: {
    broswer: "瀏覽器不支持！",
    broswer0: "當前瀏覽器相容性差，請使用 ",
    broswer1: "Chrome 瀏覽器",
  },

  login: {
    phone_number: "手機號",
    enter_phone_number: "請輸入手機號",
    enter_email_number: "請輸入郵箱",
    send_validation_code: "獲取驗證碼",
    enter_validation_code: "請輸入驗證碼",
    count_down_validation: "{second}秒後可以重試",
    login: "登錄",
    register: "註冊",
    privacy: "我同意耐克的<a class='privacy_link' style='{style}' href='/Privacy' target='_blank'>隱私政策</a>",
    language: "語言選擇",
    nike_login: "耐克內部員工登入",
    nike_register: "耐克內部員工注册",
    back_login: "返回登錄",
    pwd_tip: "如未收到驗證碼，請聯系emoment.service@nike.com",
    new_pwd: "請輸入新密碼",
    confirm_new_pwd: "請確認新密碼"
  },

  no_resources: "暫無資源",

  register: {
    division: "分類",
    category: "品類",
    gender: "性別",
    tag1: "分類",
    tag2: "品類",
    tag3: "性別",
    tag4: "TAG4",
    tag5: "TAG5",
    confirm_user_information: "確認使用者資訊",
    name: "姓名",
    gender: "性別",
    select_gender: "請選擇性別",
    male: "男",
    female: "女",
    phone: "手機號",
    old_phone: "原手机号",
    new_phone: "新手机号",
    old_email: "原郵箱",
    new_email: "新郵箱",
    password: "登錄密碼",
    confirm_password: "確認密碼",
    old_password: "請輸入舊密碼",
    new_password: "請輸入新密碼",
    pwd_placeholder: "密碼必須包含大小寫字母和數字且不少於8位",
    validation_code: "验证码",
    get_validataion_code: "获取验证码",
    change: "更改",
    email: "郵箱",
    upload_avatar: "上傳頭像",
    account_group: "客戶組",
    select_account_group: "請選擇客戶組",
    area: "區域",
    company: "公司",
    city: "城市",
    online: "線上",
    onsite: "現場",
    online_onsite_description: "該選項支援多選。但請根據您的情況，選擇參會的方式。",
    language: "語言",
    select_language: "請選擇語言",
    register: "註冊",
    privacy: "我同意耐克的<a class='privacy_link' href='/Privacy' target='_blank'>隱私政策</a>",
    reg_pending_name: "親愛的{user_name}，",
    reg_pending: "您已申請參加【{event_name}】，請等待客戶聯絡員/活動管理員批准。",
    input_name: "輸入姓名",
    input_phone: "手機號碼",
    input_email: "輸入郵箱",
    select_company: "選擇公司",
    input_location: "輸入地區",
    input_city: "輸入城市",
    select_divistion: "選擇分類",
    select_category: "選擇品類",
    select_tag_gender: "選擇性別",
    warning: "註意",
    retry_warning: "系統檢測到您已經發送了多次手機驗證碼。如您任然無法收到驗證碼，請將您的姓名，手機號，電話前綴 (+86, +886, +852, +853) 與郵箱地址通過郵件發送給我們 (郵件地址：<a href='mailto:eMoment.Service@nike.com'>eMoment.Service@nike.com</a>)。系統將會幫您創建賬號並通知您。請您在收到通知後，重新嘗試註冊登錄系統。",
  },

  update_me: {
    get_code: "獲取驗證碼",
    count_down: "{second}秒後重試",
  },

  litter_helper:{
    eMoment_litter_helper: "eMoment小助手",
    user_manual: "用戶使用手冊",
    feature_description_video: "功能介紹視頻",
    FAQ: "常見問題",
    catalog: "目錄",
    clear_the_history: "清空歷史記錄",
    history: "歷史記錄",
    search_placeholder: "請輸入關鍵詞搜索",
    no_content: "暫無內容",
    no_search:"抱歉, 沒有找到結果。請換個關鍵詞試試~",
    preparatory_phase: "準備階段",
    registration_phase: "註冊階段",
    activity_phase: "活動階段",
    activity_end: "活動結束",
    solve_problem: "是否解決了妳的問題 ?",
    solve_problem_ok: "是，已解決",
    solve_problem_no: "否， 為解決",
    feedback: "感謝您的反饋！",
    send_email: "请将您的问题编辑后发送至",
    i_know: "我知道了",
    system_admin: "系統管理員",
    event_admin: "活動管理員",
    attendee: "參會人",
    broadcaster: "播音員",
    partner_contactor: "客戶聯絡員",
    speaker: "講者",
    assistant: "產品專家",
    general: "通用",
    close_inquiry: "{count}s 後關閉",
    faq_feedback: "問題反饋",
    enter_question: "請輸入問題",
    successful_problem_feedback: "問題反饋成功"
  },

  activity:{
    no_content: "暫無活動介紹"
  },

  privacy: "隱私政策",
  system_admin: "系统设置",

  session: {
    get_obs: "獲取OBS軟件",
    obs_studio: "OBS直播軟件",
    vlc_playper: "VLC播放器",
    obs_studio_subtitle: "OBS直播軟件字幕插件",
    download: "下載",
    get_obs_start: "獲取當前頻道的推流配置",
    current_channel: "當前頻道",
    broadcast_date: "開播日期：",
    broadcast_time: "開播時間：",
    broadcast_start: "是否開播",
    join_in_chat_room: "加入該聊天室",
    session_name: "會議名稱",
    session_time: "會議時間",
    session_type: "會議類型",
    session_date: "會議日期",
    session_room_name: "會議室名稱",
    session_place: '參會地點',
    session_room: '會議室',
    estimated_video_duration: "視頻預估時長",
    video_duration: "視頻時長",
    session_detail: "會議詳情",
    speaker: "會議講者",
    session_description: "會議描述",
    video_time: "會議時長",
    back_to_event: "返回活動詳情",
    activity_introduction: "活動介紹",
    activity_session: "活動會議 (線下)",
    back_to_role_select: "返回角色選擇",
    month: "月",
    day: "天",
    hour: "小時",
    minute: "分鐘",
    second: "秒",
    chat_in_room: "聊天室：{session_name}",
    input_chat_msg: "請輸入聊天內容",
    chat_room: "聊天室",
    send: "發送",
    home: "活動列表",
    logout: "登出",
    save: "保存",
    cancel: "取消",
    notice: "注意",
    no_event: "您目前暫無活動。",
    no_session: "您目前暫無會議。",
    player_error: "直播出現了問題，請稍候刷新頁面，如依然出現此問題，請聯系管理員。",
    liveStreamStop: "當前會議已經結束",
    chapter: '章節',
    bookmark: '書籤',
    bookmark_input: '請輸入內容',
    no_bookmark: '暫無書簽',
    window_title: '視窗',
    chatroom: '聊天室',
    attendee_list: '參會人清單',
    online: '在線',
    offline: '離線',
    select: '请选择',
    to_all: '所有人',
    delete_message: '確認刪除這條消息？',
    status: '狀態',
    block: '禁言',
    block_reason: '禁言理由:',
    send_to_you: '私聊我',
    you_send_to: '我私聊',
    say: '說',
    blocking: '禁言中',
    block_count_down: '禁言倒計時：',
    someone_send_me: '有人私聊我。',
    download_chat: '下載聊天記錄',
    download_after_session: '會議結束後下載聊天記錄',
    send_to: '發給',
    okText: '確認',
    cancelText: '取消',
    bookmark_tip: "書簽簡介：點擊輸入框，記錄觀看筆記。",
    caption_tip: "字幕：點擊按鈕，字幕開啟。",
    QA: {
      enter_QA:'進入Q&A',
      preTitle: 'BRA/LEGGING 講解',
      is_mine: '僅顯示我的問題',
      show_all_question: '顯示所有問題',
      all_qa:'所有QA',
      un_answer: '未回答',
      answered: '已回答',
      closed: '未關閉',
      my_question: '我的問題',
      all_question: '所有問題',
      search_question: '搜索問題',
      is_public: '是否公開',
      input_notify: '請輸入你的問題',
      text1: '歡迎來到問答。',
      text2: '您提出的問題將會顯示在此處。',
      text3: "除私信發送外，您發送的問題將展示在『所有問題』清單。",
      confirmDel: '確定刪除問題？',
      confirmDelete: '確定刪除？',
      confirmSend: '是否提交？',
      confirmCancel: '是否取消？（取消會刪除目前的輸入）？',
      myReAsk: '我要追問',
      reAsk:'追問',
      myAsk: '我要提問',
      inputAnswer: '輸入我的回答...',
      answerNotify: '確認回答？',
      tips: '提示',
      cancelIdentify: '取消確認（取消後輸入框內容將不保留）',
      cancel: '取消',
      identify: '確認',
      modifyQAIdentify: '確認修改這條問題?',
      commit: '提交',
      contentNotify: '内容不能为空',
      total: '共',
      total1: '條',
      noSession: '未綁定會議，請聯系活動管理員',
      edit: '編輯',
      answer: '回答',
      editQuestion:'編輯問題',
      isPublic: '是否公開',
      del: '刪除',
      me: '我',
      assistant: '產品專家',
      last_edit:'上一次編輯有未發送內容,',
      use_last_edit:'使用上一次的編輯'
    }
  },

  video:{
    try_later: "視頻轉碼中，請稍後重試",
  },

  meeting: {
    warning: "提醒",
    agree_user_info: "同意",
    disagree_user_info: "不同意，返回日程列表",
    agree_rule: "用戶您好，由於提供線上會議功能所需，您參加線上會議時所顯示的名稱將提供給ZOOM並傳輸至境外伺服器，請問是否同意？",
  },

  portal: {
    participant: "參會人模組",
    admin: "管理員模組",
    partner_contact: "客戶聯絡員",
    attendee: "參會人",
    assistant: "活動助理",
    broadcaster: "播音員",
    hoster: "ZOOM主持人",
  },
  'CORE':'核心',
  'NONCORE':'非核心',
  approval: {
    not_approved: '審批中...',
    approved_pass: '審批通過',
    approved_refuse: '審批未通過',
    first_approval_pass: '一審已通過',
    first_approval_refuse: '一審未通過',
    second_approved_refuse: '二審未通過',
    first_approval_pass_tip: '一審已通過，請等待二審審批',
    first_approval_refuse_tip: '一審未通過，有疑問請聯繫客戶聯絡員',
    approved_refuse_tip: '審批未通過，有疑問請聯繫活動管理員'
  },
  event_detail: {
    approval_list: "審批列表",
    approval_report: "審批報表",
    seasonal_video: "當季視頻",
    seasonal_image: "當季圖片",
    my_event: "我的其它活動",
    report: {
      pc_approval: "Partner Contact 審批情况",
      register_table: "註冊表",
      register_table_approved: "一審已通過",
      register_table_rejected: "一審已拒絕",
      register_table_wait: "一審未操作",
      approve_table: "審批表",
      approve_table_left: "邀請剩餘名額",
      ea_approval: "Event Admin 審批情况",
      ea_table_approved: "二審已通過",
      ea_table_rejected: "二審已拒絕",
      ea_table_wait: "二審未操作",
      real_time_login: "實时登入情况",
      real_time_login_description: "從【{time}】開始，5分鐘內登錄數據。",
      actual_login: "實際登入用戶數",
      no_login: "沒有登入數",
    },
    channel_list: "頻道列表",
    download_approval_list: "下載審批列表",
    upload_approval_list: "上傳審批列表",
    online_onsite: "線上/現場",
    online: "線上",
    onsite: "現場",
    registration_status: "註冊狀態",
    confirmed_status: {
      PENDING: "待審核",
      CONFIRMED: "批準",
      REJECTED: "拒絕",
    },
    approve: "批準",
    reject: "拒絕",
    edit: "編輯",
    invitation_list: "邀請列表",
    expired_time: "邀請過期時間",
    invitation_url: "邀請鏈接",
  },

  user: {
    phone: "手機",
    email: "郵箱",
    LOCATION: "區域",
    COMPANY: "公司",
    account_group: "客戶組",
    CITY: "城市",
    account: "帳號",
    password: "密碼",
    name: "姓名",
    clear_openid: "清空OPENID",
    disabled: "已停用",
    enabled: "已啟用",
    prefix: "區號",
    gender: "性別",
    is_disabled: "帳號是否停用",
    is_internal: "內部員工",
    only_internal: "僅顯示內部員工",
    without_internal: "不顯示內部員工",
    TAG1: "TAG1",
    TAG2: "TAG2",
    TAG3: "TAG3",
    TAG4: "TAG4",
    TAG5: "TAG5",
    is_main_owner: "活動擁有者",
    is_owner: "活動管理員",
    is_partner_contact: "客戶聯絡員",
  },

  play_only_once: "只播放一次",
  no_replay_available: "不提供重播",
  account_group: "客戶組",
  action: "操作",
  back: "返回",
  event_name: "活動名稱",
  event_range: "活動時間",
  no_support_mobile: "該平臺暫時不支持手機瀏覽，請使用電腦瀏覽。",
  copy: "復製",
  confirm: "確定",
  "INVITATION URL IS INVALID.": "邀請碼無效。",
  "RELOAD TO WATCH BROADCAST.": "直播即將開始，請稍候",
  "RELOAD TO WATCH PLAYBACK.": "重播即將開始，請稍候",
  "BROADCAST IS OVER.": "該場直播已結束<br/>請等待重播或進入下一場直播",
  "PLAYBACK IS OVER.": "該場重播已結束",
  count_down_no_content: "該會議暫無內容，請聯系系統/活動管理員",
  "post bookmark success": "書簽已標記",

  mobile: {
    event_list: '我的會議',
    pass_card: '通行證',
    my_home: '個人中心',
    session_list: '會議清單',
    refresh: '刷新二維碼',
    logout: '退出登錄',
    my_sport: '運動',
    pass_in_min: '提前{min}分鐘入場',
    permission_err: '您暫時沒有參加現場會議的許可權',
    expire_time: "該二維碼有效期<br/>【{time}】<br/>請截圖備用",
  },
  sport: {
    not_begin:'活動即將開始',
    sort_order: '排列順序',
    sort_asc:'升序排序',
    sort_desc:'降序排序',
    image:'圖片',
    video:'視頻',
    chosen:'已選擇',
    cancelChoose:'取消選擇',
    batchDownload:'批量下載',
    sportScore:'項目評價',
    event_organize_well:'活動組織很好',
    event_content_well:'活動內容很好',
    environment_well:'環境很好',
    place_well:'場地很好',
    input_tip1:'您的評價會讓我們變得更好',
    commit:'提交',
    no_more:'沒有更多了~',
    register_progress:'報名進度',
    item_introduce:'項目介紹',
    tips:'溫馨提示',
    had_register:'已報名',
    stop_register:'停止報名',
    wonderful_moment:'精彩瞬間',
    over_max:'已滿員',
    register_now:'立即報名',
    tip2:'注*：如需取消報名，請至專案清單-我的專案中取消',
    register:'報名',
    cancel_identify:'確認取消報名？',
    gotoDetail:'進入詳情'
  },
  fold:'收起',
  unfold:'展開',
  man:'男',
  women:'女',
  cancel:'取消',
  commit:'提交'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-tw.js